/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react'
import ReactDatePicker from 'react-datepicker'
import { InputGroup, Input, InputRightElement } from '@chakra-ui/react'
import { CalendarIcon } from '@chakra-ui/icons'
import { useRouter } from 'next/router'
import { getDay } from 'date-fns'

const customDateInput = ({ value, onClick, onChange }: any, ref: any) => (
  <Input
    autoComplete="off"
    px="10px"
    border="1px solid"
    borderColor="black.primary3"
    variant="secondary"
    size="secondary"
    focusBorderColor="black.primary3"
    errorBorderColor="red.primary"
    value={value}
    ref={ref}
    onClick={onClick}
    fontSize="md"
    fontFamily="spectral"
    onChange={onChange}
  />
)
customDateInput.displayName = 'DateInput'

const CustomInput = forwardRef(customDateInput)

const icon = <CalendarIcon fontSize="sm" />

interface Props {
  isClearable?: boolean
  onChange: (date: Date) => unknown
  selectedDate: Date | undefined
  showPopperArrow?: boolean
  minDate?: Date
  maxDate?: Date
  filterDate?(date: Date): boolean
}

const DatePicker = ({ selectedDate, onChange, ...props }: Props) => {
  const { locale } = useRouter()
  const isWeekday = (date: Date): boolean => {
    const day = getDay(date)
    return day !== 1 && day !== 6 && day !== 0
  }
  return (
    <>
      <InputGroup className="light-theme">
        <ReactDatePicker
          selected={selectedDate}
          onChange={onChange}
          className="react-datepicker"
          customInput={<CustomInput />}
          locale={locale}
          minDate={new Date()}
          filterDate={isWeekday}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          {...props}
        />
        <InputRightElement color="gray.500">{icon}</InputRightElement>
      </InputGroup>
    </>
  )
}

export default DatePicker
